import { DropDownOption } from '@grays-npm/component-library';

// Gets used as numbers
export enum StatsDurations {
  Thirty = '30',
  Sixty = '60',
  Ninety = '90',
}

export const statisticsOptions: DropDownOption[] = [
  { value: StatsDurations.Thirty, label: 'Last 30 days' },
  { value: StatsDurations.Sixty, label: 'Last 60 days' },
  { value: StatsDurations.Ninety, label: 'Last 90 days' },
];
